/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Results_NameInputs */



/**
* | output |
* | --- |
* | "OCR Results" |
*
* @param {Ocr_Results_NameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_results_name = /** @type {((inputs?: Ocr_Results_NameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Results_NameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Résultats de la reconnaissance optique de caractères (OCR)")
	if (locale === "de") return /** @type {LocalizedString} */ ("OCR-Ergebnisse")
	if (locale === "it") return /** @type {LocalizedString} */ ("Risultati OCR")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Результаты OCR")
	if (locale === "es") return /** @type {LocalizedString} */ ("Resultados de OCR")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("OCR结果")
	if (locale === "ja") return /** @type {LocalizedString} */ ("OCRの結果")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ओसीआर परिणाम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Resultados de OCR")
	return /** @type {LocalizedString} */ ("OCR Results")
});